import React from "react";

export default function CustomerPricing() {
  return (
    <div id="CustomerPricing" className="tab-pane fade">
      Customer Pricing
    </div>
  );
}
